module.exports = __webpack_public_path__ + "media/images/landing/second/photo6-b0b43129bc793f597cdb1db8d80bc1a6.jpg";